export const HEADER_HEIGHT = 45;
export const NAVIGATION_WIDTH = 200;
